// extracted by mini-css-extract-plugin
export default {"container":"AuthorInfo_container__ExlLG"};